import React from "react";
import { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar/Sidebar";
import BootstrapTable from 'react-bootstrap-table-next';
import pagination from './pagination';
import "./Stax.css";
import { Roller } from "react-awesome-spinners";
import { getuserdataapi, deleteMultipleUser } from "../Api/crm";
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import { Modal } from 'react-bootstrap';
import ChildComponent from '../Components/EditUser/Informasi';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { CSVLink } from 'react-csv';



function LillypadCleanup() {
    const [loading, setLoading] = useState(false);
    const [staxdata, setStaxdata] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);

    const [showConfirm, setShowConfirm] = useState(false);

    const handleCloseConfirm = () => setShowConfirm(false);
    const handleShowConfirm = () => setShowConfirm(true);
    const [limit, setLimit] = useState(1);



    const getuserdata = () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("limit", limit);
        getuserdataapi(formData)
            .then((response) => {
                if (response.code === 200) {
                    const apiResponse = response.data;

                    // Check if the API status is success
                    if (apiResponse.status === 1) {
                        const fetchedMargedata = apiResponse.data;
                        setStaxdata(fetchedMargedata);
                    } else {
                        setStaxdata([]);
                    }
                } else {
                    setStaxdata([]);
                }
            })
            .catch(function (err) {
                // Handle network or unexpected errors
                console.error("Error fetching data:", err);
                alert("An error occurred while fetching data. Please check your connection or try again later.");
                setStaxdata([]);
            })
            .finally(() => {
                // Hide the loading spinner after the request completes
                setLoading(false);
            });
    };


    useEffect(() => {
        getuserdata();
    }, []);


    const [currentsatxuserid, setCurrentsatxuserid] = useState(0);

    const handleCheckboxChange = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = staxdata.map((item) => item.id).filter(Boolean); // ensure no undefined
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };



    const [deleteloader, setDeleteloader] = useState(false);

    const startlillypadCleanup = () => {
        setDeleteloader(true);
        const formData = new FormData();
        formData.append("ids", selectedIds);
        deleteMultipleUser(formData).then((response) => {
            if (response.code === 200) {
                const apiResponse = response.data;
                if (apiResponse.status == "success") {
                    // setDelcount(prevCount => prevCount + 1); 
                    setDeleteloader(false);
                    window.location.reload();
                } else {
                    alert("user delete failed");
                }
            }
        });
    }


    const [usercrmid, setUsercrmid] = useState(0);

    const callChildFunction = (userid) => {
        setUsercrmid(userid);
    };



    const columns = [
        {
            dataField: 'select',
            text: (
                <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectedIds.length === staxdata.length}
                />
            ),
            formatter: (cellContent, row) => {
                console.log('Render Row ID:', row.id, 'Checked:', selectedIds.includes(row.id));
                return (
                    <input
                        type="checkbox"
                        checked={selectedIds.includes(row.id)}
                        onChange={() => handleCheckboxChange(row.id)}
                    />
                );
            },
            headerStyle: () => ({ width: '60px' }),
        },
        {
            dataField: 'id',
            text: 'User ID',
            sort: true,
        },
        {
            dataField: 'name',
            text: 'Name',
            formatter: (cell, row) => (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        callChildFunction(row.id);
                    }}
                >
                    {row.name}
                </a>
            ),
            sort: true,
        },
        {
            dataField: 'user_email',
            text: 'Email',
            formatter: (cell, row, rowIndex) => (
                <div id={`user_email_${rowIndex + 1}`}>{row.user_email}</div>
            ),
        },
        {
            dataField: 'customer_id',
            text: 'Stax',
            formatter: (cell, row) => {
                return (
                    cell ? (
                        <a
                            href={`https://app.staxpayments.com/#/customers?keywords[]=${encodeURIComponent(row?.user_email?.replace(/[:\s]/g, "").trim())}&page=1`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {cell}
                        </a>
                    ) : 'No'
                );
            },
            sort: true,
        },
        {
            dataField: 'customer_stage',
            text: 'Customer Stage',
            sort: true,
        },
        {
            dataField: 'bookings',
            text: 'No. of bookings',
            formatter: () => 0,
        },
        {
            dataField: 'last_booking_date',
            text: 'Last Booking date',
            sort: true,
        },
        {
            dataField: 'cus_dt',
            text: 'Create Date',
            formatter: (cell) => {
                const date = new Date(cell);
                return date.toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                });
            },
        },
    ];



    const customRowRender = (row, index) => {
        const currentUserIndex = index + 1;
        const isCurrent = currentUserIndex === currentsatxuserid;
        const isLast = currentUserIndex < staxdata.length;

        if (isCurrent && isLast) {
            return (
                <div style={{ textAlign: 'center', padding: '10px' }}>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            );
        }
        return null;
    };

    const csvReport = {
        data: staxdata.map(item => {
            return {
                name: (item.name || '').trim(),
                email: (item.user_email || '').trim(),
                stax_id: (item.customer_id || '').trim(),
                joinon: item.cus_dt,
                keap_id: item.keap_id
            };
        }),
        headers: [
            { label: "NAME", key: "name" },
            { label: "EMAIL", key: "email" },
            { label: "STAX ID", key: "stax_id" },
            { label: "JOIN ON", key: "joinon" },
            { label: "KEAP ID", key: "keap_id" },
        ],
        filename: 'cleanup.csv'
    }

    return (
        <div>
            {
                loading ? (
                    <div className="loading">
                        <Roller size={50} color="#75b317" />
                    </div>
                ) : (<>

                    <Modal show={showConfirm} onHide={handleCloseConfirm}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Action</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to perform this action?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseConfirm}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={startlillypadCleanup}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <div className="dashboard-container d-flex">
                        <div className="sidebar-container">
                            <Sidebar />
                        </div>
                        <div className="main-container">
                            <div className="main-page-body-content">
                                {/* <div className="main-page-body-content-header">
                                    <Header />
                                </div> */}
                                <div className="main-page-body-content-body">
                                    <div className="main-page-body-content-body-container">
                                        <div className="container-fulid">
                                            <div className="">
                                                <div className="table-card ">
                                                    <div className="card-body table-card-body">
                                                        <div className="table-card-header">
                                                            <h5 className="card-title">Lillypad data</h5>
                                                        </div>
                                                        <div className="table-card-body-inner">
                                                            <div className="animated fadeIn">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="card">
                                                                            <div className="card-header d-flex justify-content-between table-card-header" >
                                                                                <div className="card-header d-flex table-card-header justify-content-between align-items-center px-0">
                                                                                    <div className="ml-auto d-flex align-items-end">

                                                                                        {
                                                                                            deleteloader ? (
                                                                                                <Button
                                                                                                    disabled
                                                                                                    className="btn btn-sm float-right add-user-btn ms-0"
                                                                                                >
                                                                                                    Deleting...
                                                                                                </Button>
                                                                                            ) : (
                                                                                                <Button
                                                                                                    onClick={handleShowConfirm}
                                                                                                    className="btn btn-sm float-right add-user-btn ms-0"
                                                                                                >
                                                                                                    Delete User
                                                                                                </Button>
                                                                                            )
                                                                                        }

                                                                                        <div className="d-flex flex-column">
                                                                                            <label>
                                                                                                Older than
                                                                                            </label>
                                                                                            <select className="btn btn-sm ms-0 bg-secondary text-white"
                                                                                                style={{
                                                                                                    backgroundColor: '#75B317 !important',
                                                                                                    border: '1px solid #75B317 !important',
                                                                                                    height: '38px',
                                                                                                    // padding: '0px 20px',
                                                                                                    fontSize: '15px',
                                                                                                    fontWeight: '500',
                                                                                                    color: '#ffffff !important',
                                                                                                    margin: '0px 10px'
                                                                                                }}
                                                                                                value={limit} onChange={(e) => setLimit(e.target.value)}>
                                                                                                <option value={1}>1 Month</option>
                                                                                                <option value={2}>2 Month</option>
                                                                                                <option value={3}>3 Month</option>
                                                                                                <option value={4}>4 Month</option>
                                                                                                <option value={5}>5 Month</option>
                                                                                                <option value={6}>6 Month</option>
                                                                                                <option value={7}>7 Month</option>
                                                                                                <option value={8}>8 Month</option>
                                                                                                <option value={9}>9 Month</option>
                                                                                                <option value={10}>10 Month</option>
                                                                                                <option value={11}>11 Month</option>
                                                                                                <option value={12}>12 Month</option>
                                                                                            </select>
                                                                                        </div>

                                                                                        <Button
                                                                                            className="btn btn-sm float-right add-user-btn ms-0"
                                                                                            onClick={getuserdata}
                                                                                        >
                                                                                            Get Data
                                                                                        </Button>

                                                                                        <CSVLink {...csvReport}>
                                                                                            <button className="btn btn-primary downloads-btn-preview me-1">Export CSV</button>
                                                                                        </CSVLink>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="card-body">

                                                                                {/* <Table striped bordered hover>
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th><input
                                                                                                type="checkbox"
                                                                                                onChange={handleSelectAll}
                                                                                                checked={selectedIds.length === staxdata.length}
                                                                                            />
                                                                                            </th>
                                                                                            <th>userId</th>
                                                                                            <th>Name</th>
                                                                                            <th>Email</th>
                                                                                            <th>Stax</th>
                                                                                            <th>No. of. bookings</th>
                                                                                            <th>Create Date</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {Array.isArray(staxdata) && staxdata.length > 0 ? (
                                                                                            staxdata.map((item, index) => {
                                                                                                const currentUserIndex = index + 1;
                                                                                                const isCurrent = currentUserIndex === currentsatxuserid;
                                                                                                const isLast = currentUserIndex < staxdata.length;

                                                                                                return (
                                                                                                    <React.Fragment key={item.id || currentUserIndex}>
                                                                                                        {isCurrent && isLast ? (
                                                                                                            <tr>
                                                                                                                <td colSpan={6} style={{ textAlign: 'center' }}>
                                                                                                                    <Spinner
                                                                                                                        as="span"
                                                                                                                        animation="border"
                                                                                                                        size="sm"
                                                                                                                        role="status"
                                                                                                                        aria-hidden="true"
                                                                                                                    />
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        ) : (
                                                                                                            <tr id={`user_id_${currentUserIndex}`}>
                                                                                                                <td>
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        checked={selectedIds.includes(index)}
                                                                                                                        onChange={() => handleCheckboxChange(index)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>{item.id}</td>
                                                                                                                <td><a
                                                                                                                    href="#"
                                                                                                                    onClick={(e) => {
                                                                                                                        e.preventDefault();
                                                                                                                        callChildFunction(item.id);
                                                                                                                    }}
                                                                                                                >{item.name}  </a></td>
                                                                                                                <td id={`user_email_${currentUserIndex}`}>{item.user_email}</td>
                                                                                                                <td>{item.customer_id ?? "No"}</td>
                                                                                                                <td>{0}</td>
                                                                                                                <td>
                                                                                                                    {new Date(item.cus_dt).toLocaleString('en-US', {
                                                                                                                        year: 'numeric',
                                                                                                                        month: '2-digit',
                                                                                                                        day: '2-digit',
                                                                                                                        hour: '2-digit',
                                                                                                                        minute: '2-digit',
                                                                                                                        second: '2-digit',
                                                                                                                    })}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        )}
                                                                                                    </React.Fragment>
                                                                                                );
                                                                                            })
                                                                                        ) : (
                                                                                            <tr>
                                                                                                <td colSpan={8} style={{ textAlign: 'center' }}>
                                                                                                    No Data Found
                                                                                                </td>
                                                                                            </tr>
                                                                                        )}


                                                                                    </tbody>
                                                                                </Table> */}

                                                                                <BootstrapTable
                                                                                    keyField="id"
                                                                                    key={selectedIds.join(',')}
                                                                                    data={staxdata}
                                                                                    columns={columns}
                                                                                    bordered
                                                                                    hover
                                                                                    condensed
                                                                                    pagination={paginationFactory()}
                                                                                />


                                                                                {
                                                                                    usercrmid != 0 ? (
                                                                                        <ChildComponent id={usercrmid} onCloseidChange={(editid) => setUsercrmid(editid)} />
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                )}
        </div>
    );
}

export default LillypadCleanup;